/**
 * Normalize smart-playlist detail rows (API snake_case) for UI + playback.
 */

import { durationFromTrackRow } from '../utils/trackDuration';
import { qobuzStaticCoverUrl } from '../utils/qobuzStaticCoverUrl';

export function isSmartPlaylistV2Blueprint(blueprint) {
  return blueprint?.wizardVersion === 2 || blueprint?.wizardVersion === '2';
}

export function normalizeSmartPlaylistDetailTrack(tr) {
  if (!tr) return tr;
  const trackId = tr.track_id ?? tr.trackId ?? tr.id ?? tr.qobuzTrackId;
  const cover = tr.cover_url || tr.coverUrl || tr.artworkUrl || qobuzStaticCoverUrl(tr.album_id || tr.albumId) || '';
  const artist = tr.artist_name || tr.artistName || tr.artist || '';
  const album = tr.album_title || tr.albumTitle || tr.album || '';
  return {
    ...tr,
    id: trackId,
    track_id: trackId,
    trackId,
    qobuzTrackId: trackId,
    artist_name: artist,
    artistName: artist,
    artist,
    album_title: album,
    albumTitle: album,
    album,
    album_id: tr.album_id ?? tr.albumId,
    albumId: tr.album_id ?? tr.albumId,
    cover_url: cover,
    coverUrl: cover,
    artworkUrl: cover,
  };
}

export function normalizeSmartPlaylistDetailTracks(tracks) {
  return (tracks || []).map(normalizeSmartPlaylistDetailTrack);
}

/** Flat track shape for QueueController.playFrom / playSingle. */
export function formatSmartPlaylistTrackForPlayback(tr) {
  const n = normalizeSmartPlaylistDetailTrack(tr);
  return {
    id: n.id,
    qobuzTrackId: n.qobuzTrackId,
    title: n.title || 'Unknown',
    artist: n.artist || 'Unknown',
    album: n.album || '',
    albumId: n.albumId || '',
    artworkUrl: n.artworkUrl || '',
    duration: durationFromTrackRow(n) ?? n.duration_seconds ?? n.duration ?? 0,
    duration_ms: n.duration_ms,
    duration_seconds: n.duration_seconds,
    source: 'qobuz',
  };
}

export function smartPlaylistQueueItem(tr) {
  const n = formatSmartPlaylistTrackForPlayback(tr);
  return {
    track: {
      ...n,
      streamUrl: '',
    },
  };
}
